import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const GrantAccessIconv3 = (props: SvgProps) => (
  <Svg
    width={25}
    height={25}
    fill="none"
    {...props}
  >
    <Path
      fill="#AE4D28"
      fillRule="evenodd"
      d="M18.765.217C15.332 7.028 7.028 9.767.217 6.333H.216l-.001.001.001.001c6.81 3.433 9.549 11.736 6.118 18.546h.001c3.41-6.763 11.623-9.51 18.406-6.186C18.033 15.22 15.355 6.983 18.765.22V.217Z"
      clipRule="evenodd"
    />
  </Svg>
)
export default GrantAccessIconv3
